/* eslint-disable no-console */
import $service from '../util/service';

export default {
   HOME_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.homePageData
         ? true
         : $service
              .get('/homePage')
              .then(response =>
                 commit('SET_HOME_PAGE_DATA', {
                    data: response.data,
                 })
              )
              .catch(error => {
                 console.log(error);
              }),

   CHINESE_HOME_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.chineseHomePageData
         ? true
         : $service
              .get('/chineseHomePage')
              .then(response =>
                 commit('SET_CHINESE_HOME_PAGE_DATA', {
                    data: response.data,
                 })
              )
              .catch(error => {
                 console.log(error);
              }),

   RESOURCE_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.resourcePageData
         ? true
         : $service
              .get('/resourcesPage')
              .then(response =>
                 commit('SET_RESOURCE_PAGE_DATA', {
                    data: response.data,
                 })
              )
              .catch(error => {
                 console.log(error);
              }),
   DASHBOARD_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.dashboardPageData
         ? true
         : $service
              .get('/dashboardPage')
              .then(response =>
                 commit('SET_DASHBOARD_PAGE_DATA', {
                    data: response.data,
                 })
              )
              .catch(error => {
                 console.log(error);
              }),
   NONCOMMERCIAL_PAGE_DATA_FETCH: ({ commit }) =>
      $service
         .get('/non-commercial')
         .then(response => {
            commit('SET_NONCOMMERCIAL_DATA', {
               data: response.data,
            });
         })
         .catch(err => {
            console.log((err && err.response && err.response.status) || err);
            if (err && err.response && err.response.status === 404) {
               commit('SET_NONCOMMERCIAL_DATA', {
                  data: false,
               });
            }
         }),

   DASHBOARD_SLUG_PAGE_DATA_FETCH: ({ commit }, payload) =>
      $service
         .get(`/dashboardPage/${payload.slug}`)
         .then(response =>
            commit('SET_DASHBOARD_SLUG_PAGE_DATA', {
               data: response.data,
            })
         )
         .catch(err => {
            console.log((err && err.response && err.response.status) || err);
            if (err && err.response && err.response.status === 404) {
               commit('SET_DASHBOARD_SLUG_PAGE_DATA', {
                  data: false,
               });
            }
         }),

   DOWNLOAD_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.downloadPageData
         ? true
         : $service
              .get('/downloadPage')
              .then(response =>
                 commit('SET_DOWNLOAD_PAGE_DATA', {
                    data: response.data,
                 })
              )
              .catch(error => {
                 console.log('Download Page Throwing: ', error);
              }),

   CUSTOMER_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.customerPageData
         ? true
         : $service
              .get('/customersPage')
              .then(response =>
                 commit('SET_CUSTOMER_PAGE_DATA', {
                    data: response.data,
                 })
              )
              .catch(error => {
                 console.log(error);
              }),

   NAVBAR_NAVIGATION_DATA_FETCH: ({ commit, state }, { section, stateName }) =>
      state[stateName]
         ? true
         : $service
              .get(`/navigation/${section}`)
              .then(response => {
                 commit('SET_NAVBAR_NAVIGATION_DATA', {
                    data: response.data,
                    stateName,
                 });
              })
              .catch(error => {
                 console.log(error);
              }),

   RESOURCE_SLUG_PAGE_DATA_FETCH: ({ commit }, payload) =>
      $service
         .get(`/resourcesPage/${payload.section}/${payload.slug}`)
         .then(response =>
            commit('SET_RESOURCE_SLUG_PAGE_DATA', {
               data: response.data,
            })
         )
         .catch(err => {
            console.log((err && err.response && err.response.status) || err);
            if (err && err.response && err.response.status === 404) {
               commit('SET_RESOURCE_SLUG_PAGE_DATA', {
                  data: false,
               });
            }
         }),
   WHITEPAPER_PDF_SLUG_PAGE_DATA_FETCH: ({ commit }, payload) =>
      $service
         .get(`/whitepaper/${payload.slug}`)
         .then(response =>
            commit('SET_WHITEPAPER_PDF_SLUG_PAGE_DATA_FETCH', {
               data: response.data,
            })
         )
         .catch(err => {
            console.log((err && err.response && err.response.status) || err);
            if (err && err.response && err.response.status === 404) {
               commit('SET_WHITEPAPER_PDF_SLUG_PAGE_DATA_FETCH', {
                  data: false,
               });
            }
         }),

   MAPS_PAGE_DATA_FETCH: async ({ commit }, { type, name, language = 'js' }) => {
      const mutation = 'SET_MAPS_PAGE_DATA';
      try {
         const response = await $service.get(`/explore/map-gallery/${type}/${name}/${language}`);
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: {},
            });
         }
         return false;
      }
   },

   ALL_MAP_PAGE_DATA_FETCH: ({ commit }) =>
      $service
         .get('/mapsGallery')
         .then(response => {
            commit('SET_ALLMAPS_DATA', {
               data: response.data,
            });
         })
         .catch(err => {
            console.log((err && err.response && err.response.status) || err);
            if (err && err.response && err.response.status === 404) {
               commit('SET_ALLMAPS_DATA', {
                  data: false,
               });
            }
         }),

   CUSTOMER_SLUG_PAGE_DATA_FETCH: ({ commit }, payload) =>
      $service
         .get(`/customersPage/${payload.slug}`)
         .then(response =>
            commit('SET_CUSTOMER_SLUG_PAGE_DATA', {
               data: response.data,
            })
         )
         .catch(err => {
            console.log((err && err.response && err.response.status) || err);
            if (err && err.response && err.response.status === 404) {
               commit('SET_CUSTOMER_SLUG_PAGE_DATA', {
                  data: false,
               });
            }
         }),

   CHART_TYPE_OVERVIEW_DATA_FETCH: async ({ commit }, { type }) => {
      const mutation = 'SET_CHARTS_TYPE_OVERVIEW_DATA';
      try {
         const response = await $service.get(`/explore/chart-gallery/${type}`);
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   PLAYGROUND_PAGE_DATA_FETCH: async ({ commit }, { type, name, language = 'js' }) => {
      const mutation = 'SET_PLAYGROUND_DATA';

      try {
         const response = await $service.get(`/explore/chart-gallery/${type}/${name}/${language}`);
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   PLAYGROUND_PAGE_CODE_FETCH: async ({ commit }, { slug, language, isStatic }) => {
      const mutation = 'SET_PLAYGROUND_CODE';
      try {
         const response = await $service.get(`/explore/generate/${slug}/${language}/${isStatic}`);
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: {},
            });
         }
         return false;
      }
   },
   PLAYGROUND_PAGE_CODE_FETCH_NEWCHART: async ({ commit }, { slug, language, isStatic }) => {
      const mutation = 'SET_PLAYGROUND_CODE';
      try {
         const response = await $service.get(`/explore/generate-from-apilayer/${slug}`);
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: {},
            });
         }
         return false;
      }
   },

   PRICING_PAGE_DATA_FETCH: ({ commit }) =>
      $service
         .get('/pricingPage')
         .then(response => {
            commit('SET_PRICING_DATA', {
               data: response.data,
            });
         })
         .catch(err => {
            console.log((err && err.response && err.response.status) || err);
            if (err && err.response && err.response.status === 404) {
               commit('SET_PRICING_DATA', {
                  data: false,
               });
            }
         }),

   SUPPORT_PAGE_DATA_FETCH: ({ commit }) =>
      $service
         .get('/support')
         .then(response => {
            commit('SET_SUPPORT_DATA', {
               data: response.data,
            });
         })
         .catch(err => {
            console.log((err && err.response && err.response.status) || err);
            if (err && err.response && err.response.status === 404) {
               commit('SET_SUPPORT_DATA', {
                  data: false,
               });
            }
         }),

   // PROMOTIONAL_BANNER_DATA_FETCH: ({ commit }) =>
   //    $service
   //       .get('/promotionBanner')
   //       .then(response => {
   //          console.log(response);
   //          commit('SET_PROMOTIONAL_DATA', {
   //             data: response.data,
   //          });
   //       })
   //       .catch(err => {
   //          console.log((err && err.response && err.response.status) || err);
   //          if (err && err.response && err.response.status === 404) {
   //             commit('SET_PROMOTIONAL_DATA', {
   //                data: false,
   //             });
   //          }
   //       }),

   EULA_PERPETUAL_PAGE_DATA_FETCH: ({ commit }) =>
      $service
         .get('/eulaPerpetualPageData')
         .then(response => {
            commit('SET_EULA_PERPETUAL_PRICING_DATA', {
               data: response.data,
            });
         })
         .catch(err => {
            console.log((err && err.response && err.response.status) || err);
            if (err && err.response && err.response.status === 404) {
               commit('SET_EULA_PERPETUAL_PRICING_DATA', {
                  data: false,
               });
            }
         }),

   PRIVACY_POLICY_PAGE_DATA_FETCH: ({ commit }) =>
      $service
         .get('/privacyPolicyPageData')
         .then(response => {
            commit('SET_PRIVACY_POLICY_DATA', {
               data: response.data,
            });
         })
         .catch(err => {
            console.log((err && err.response && err.response.status) || err);
            if (err && err.response && err.response.status === 404) {
               commit('SET_PRIVACY_POLICY_DATA', {
                  data: false,
               });
            }
         }),
   RESELLERS_FAQ_PAGE_DATA_FETCH: ({ commit }) =>
      $service
         .get('/ResellersFaqsPageData')
         .then(response => {
            commit('SET_RESELLERS_FAQ_DATA', {
               data: response.data,
            });
         })
         .catch(err => {
            console.log((err && err.response && err.response.status) || err);
            if (err && err.response && err.response.status === 404) {
               commit('SET_RESELLERS_FAQ_DATA', {
                  data: false,
               });
            }
         }),

   PLAYGROUND_SIDEBAR_DATA_FETCH: ({ commit, state }) =>
      state.playgroundSidebarData
         ? true
         : $service
              .get('/explore/sidebar')
              .then(response => {
                 const filterArrayRecursively = arr => {
                    const filteredArr = [];
                    for (let index = 0, max = arr ? arr.length : 0; index < max; index++) {
                       filteredArr.push({
                          header: arr[index].header,
                          link: arr[index].link,
                          items: filterArrayRecursively(arr[index].items),
                       });
                    }
                    return filteredArr;
                 };
                 const responseData = filterArrayRecursively(response.data.items);

                 commit('SET_PLAYGROUND_SIDEBAR_DATA', {
                    data: responseData,
                 });
              })
              .catch(err => {
                 console.log((err && err.response && err.response.status) || err);
                 if (err && err.response && err.response.status === 404) {
                    commit('SET_PLAYGROUND_SIDEBAR_DATA', {
                       data: false,
                    });
                 }
              }),

   OVERVIEW_INTEGRATIONS_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.overviewIntegrationsData
         ? true
         : $service
              .get('/explore/integrations')
              .then(response => {
                 commit('SET_OVERVIEW_INTEGRATIONS_DATA', {
                    data: response.data,
                 });
              })
              .catch(err => {
                 console.log((err && err.response && err.response.status) || err);
                 if (err && err.response && err.response.status === 404) {
                    commit('SET_OVERVIEW_INTEGRATIONS_DATA', {
                       data: false,
                    });
                 }
              }),

   CAREERS_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.careersPageData
         ? true
         : $service
              .get('/careersPage')
              .then(response =>
                 commit('SET_CAREERS_PAGE_DATA', {
                    data: response.data,
                 })
              )
              .catch(error => {
                 console.log(error);
              }),

   TEAM_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.teamPageData
         ? true
         : $service
              .get('/teamPage')
              .then(response =>
                 commit('SET_TEAM_PAGE_DATA', {
                    data: response.data,
                 })
              )
              .catch(error => {
                 console.log(error);
              }),

   INTEGRATIONS_PAGE_DATA_FETCH: async ({ commit }, { stack, language }) => {
      const mutation = 'SET_INTEGRATIONS_DATA';

      try {
         const response = await $service.get(`/explore/integrations/${stack}/${language}`);
         return commit(mutation, {
            data: response.data,
         });
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   INTEGRATIONS_PAGE_CODE_FETCH: async ({ commit }, { stack, language, tab }) => {
      const mutation = 'SET_INTEGRATIONS_CODE';
      try {
         const response = await $service.get(`/explore/integrations/${stack}/${language}/${tab}`);
         return commit(mutation, {
            data: response.data,
            tab,
         });
      } catch (err) {
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: {},
            });
         }
         return false;
      }
   },

   CHART_GUIDE_SLUG_PAGE_DATA_FETCH: async ({ commit }, { slug }) => {
      const mutation = 'SET_CHART_GUIDE_SLUG_PAGE_DATA';
      try {
         const response = await $service.get(`/chartguidePage/${slug}`);
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   OVERVIEW_ACCESSIBILITY_PAGE_DATA_FETCH: async ({ commit }) => {
      const mutation = 'SET_OVERVIEW_ACCESSIBILITY_DATA';

      try {
         const response = await $service.get('/accessibilityPage');
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   ACCESSIBILITY_SLUG_PAGE_DATA_FETCH: async ({ commit }, { slug }) => {
      const mutation = 'SET_ACCESSIBILITY_SLUG_PAGE_DATA';

      try {
         const response = await $service.get(`/accessibilityPage/${slug}`);
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   FUSIONTIME_EXAMPLES_FETCH: async ({ commit }) => {
      const mutation = 'SET_FUSIONTIME_EXAMPLES_DATA';

      try {
         const response = await $service.get('/explore/fusiontime/examples');
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   FUSIONTIME_DETAILS_FETCH: async ({ commit }, { slug, language = 'js' }) => {
      const mutation = 'SET_FUSIONTIME_DETAILS_DATA';

      try {
         const response = await $service.get(`/explore/fusiontime/examples/${slug}/${language}`);
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   OVERVIEW_TIME_SERIES_PAGE_DATA_FETCH: async ({ commit }) => {
      const mutation = 'SET_TIME_SERIES_PAGE_DATA';

      try {
         const response = await $service.get('/explore/fusiontime');
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   OVERVIEW_FEATURE_GALLERY_PAGE_DATA_FETCH: async ({ commit }) => {
      const mutation = 'SET_FEATURE_GALLERY_PAGE_DATA';

      try {
         const response = await $service.get('/features');
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   FEATURE_GALLERY_DETAILED_SLUG_PAGE_DATA_FETCH: async ({ commit }, { slug }) => {
      const mutation = 'SET_FEATURE_GALLERY_DETAILED_SLUG_PAGE_DATA';

      try {
         const response = await $service.get(`/features/${slug}`);
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   PARTNERS_PAGE_DATA_FETCH: async ({ commit }) => {
      const mutation = 'SET_PARTNERS_DATA';

      try {
         const response = await $service.get('/partners');
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   FUSIONEXPORT_PAGE_DATA_FETCH: async ({ commit }) => {
      const mutation = 'SET_FUSIONEXPORT_DATA';

      try {
         const response = await $service.get('/fusionexportPage');
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   OVERVIEW_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.overviewData
         ? true
         : $service
              .get('/explore/chart-gallery')
              .then(response => {
                 commit('SET_OVERVIEW_DATA', {
                    data: response.data,
                 });
              })
              .catch(err => {
                 console.log((err && err.response && err.response.status) || err);
                 if (err && err.response && err.response.status === 404) {
                    commit('SET_OVERVIEW_DATA', {
                       data: false,
                    });
                 }
              }),

   RESELLER_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.resellerData
         ? true
         : $service
              .get('/resellerPage')
              .then(response => {
                 commit('SET_RESELLER_DATA', {
                    data: response.data,
                 });
              })
              .catch(err => {
                 console.log((err && err.response && err.response.status) || err);
                 if (err && err.response && err.response.status === 404) {
                    commit('SET_RESELLER_DATA', {
                       data: false,
                    });
                 }
              }),

   RESELLER_SLUG_PAGE_DATA_FETCH: async ({ commit }, { slug }) => {
      const mutation = 'SET_RESELLER_SLUG_PAGE_DATA';

      try {
         const response = await $service.get(`/resellerPage/${slug}`);
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   RESOURCE_PAGE_SIDE_NAVIGATION_DATA: ({ commit }, { section }) =>
      $service
         .get(`/navigation/${section}`)
         .then(response => {
            commit('SET_RESOURCE_PAGE_SIDE_NAVIGATION_DATA', {
               data: response.data,
            });
         })
         .catch(err => {
            console.log((err && err.response && err.response.status) || err);
            if (err && err.response && err.response.status === 404) {
               commit('SET_OVERVIEW_INTEGRATIONS_DATA', {
                  data: false,
               });
            }
         }),

   STATIC_PAGE_DATA_FETCH: async ({ commit }, { slug }) => {
      const mutation = 'SET_STATIC_DATA';

      try {
         const response = await $service.get({
            type: 'page',
            search: slug,
         });
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   ABOUT_PAGE_DATA_FETCH: async ({ commit }) => {
      const mutation = 'SET_ABOUT_PAGE_DATA';

      try {
         const response = await $service.get('/about-us');
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   COMPARISON_PAGE_DATA_FETCH: async ({ commit }) => {
      const mutation = 'SET_COMPARISON_PAGE_DATA';
      try {
         const response = await $service.get('/comparisonPage');
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },
   COMPARISON_NEW_DETAILED_PAGE_DATA_FETCH: async ({ commit }, { slug }) => {
      const mutation = 'SET_COMPARISON_NEW_DETAILED_PAGE_DATA';
      try {
         const response = await $service.get(`/compare/${slug}`);
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },
   COMPARISON_DETAILED_PAGE_DATA_FETCH: async ({ commit }, { slug }) => {
      const mutation = 'SET_COMPARISON_DETAILED_PAGE_DATA';
      try {
         const response = await $service.get(`/javascript-charting-comparison/${slug}`);
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   // action is an async function which retrieves the data
   // from the database or from API
   // commit will access mutation
   // second params is what you have shared when called
   FC_VS_OTHERS_COMPARISON_PAGE_DATA_FETCH: async ({ commit, state }, { product }) => {
      // define which mutation it is going change
      const mutation = 'SET_FC_VS_OTHERS_COMPARISON_PAGE_DATA';
      // will excute commands in try catch to handle errors and success
      try {
         // const product = 'google-charts';
         const key = `fusionchartsVS${product.split('-').join('')}`;
         console.log('==========inside action key & data', key, state[key]);
         if (state[key]) {
            console.log('Ignore!! - Found in state: duplicate request');
            return true;
         }
         // get the response by calling GET method
         // $service use Create instance of axios inwhich you can do CURD opeations
         const response = await $service.get(
            `/javascript-charting-comparison/fusioncharts/${product}`
         );
         // console.log('==============response', response);
         // once we get the data store it in state
         commit(mutation, {
            data: response.data,
            slug: key,
         });
         return true;
      } catch (err) {
         console.error('Action failed to load data', err);
      }

      return false;
   },

   CONTACT_US_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.resellerData
         ? true
         : $service
              .get('/contactUsPage')
              .then(response => {
                 commit('SET_CONTACT_US_DATA', {
                    data: response.data,
                 });
              })
              .catch(err => {
                 console.log((err && err.response && err.response.status) || err);
                 if (err && err.response && err.response.status === 404) {
                    commit('SET_CONTACT_US_DATA', {
                       data: false,
                    });
                 }
              }),

   CONTACT_SALES_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.resellerData
         ? true
         : $service
              .get('/contactSalesPage')
              .then(response => {
                 commit('SET_CONTACT_SALES_DATA', {
                    data: response.data,
                 });
              })
              .catch(err => {
                 console.log((err && err.response && err.response.status) || err);
                 if (err && err.response && err.response.status === 404) {
                    commit('SET_CONTACT_SALES_DATA', {
                       data: false,
                    });
                 }
              }),
   NEWSLETTER_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.resellerData
         ? true
         : $service
              .get('/newsltterPage')
              .then(response => {
                 commit('SET_NEWSLETTER_DATA', {
                    data: response.data,
                 });
              })
              .catch(err => {
                 console.log((err && err.response && err.response.status) || err);
                 if (err && err.response && err.response.status === 404) {
                    commit('SET_NEWSLETTER_DATA', {
                       data: false,
                    });
                 }
              }),

   CONTACT_SUPPORT_PAGE_DATA_FETCH: ({ commit, state }) =>
      state.resellerData
         ? true
         : $service
              .get('/contactSupportPage')
              .then(response => {
                 commit('SET_CONTACT_SUPPORT_DATA', {
                    data: response.data,
                 });
              })
              .catch(err => {
                 console.log((err && err.response && err.response.status) || err);
                 if (err && err.response && err.response.status === 404) {
                    commit('SET_CONTACT_SUPPORT_DATA', {
                       data: false,
                    });
                 }
              }),

   DATA_STORIES_OVERVIEW_PAGE_DATA_FETCH: async ({ commit }) => {
      const mutation = 'SET_DATA_STORIES_OVERVIEW_PAGE_DATA';

      try {
         const response = await $service.get('/explore/data-stories');
         return commit(mutation, {
            data: response.data,
         });
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   DATA_STORIES_PAGE_DATA_FETCH: async ({ commit }, { name }) => {
      const mutation = 'SET_DATA_STORIES_PAGE_DATA';

      try {
         const response = await $service.get(`/explore/data-stories/${name}`);
         return commit(mutation, {
            data: response.data,
         });
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   PRODUCT_GALLERY_DATA_FETCH: async ({ commit }) => {
      const mutation = 'SET_PRODUCT_GALLERY_DATA';

      try {
         const response = await $service.get(`/explore/product-gallery`);
         return commit(mutation, {
            data: response.data,
         });
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   PAGE_JSON_SCHEMA: async ({ commit }, { schema }) => {
      const mutation = 'SET_PAGE_JSON_SCHEMA';

      try {
         const response = await $service.get(`/data/schema/${schema}`);
         return commit(mutation, {
            data: response.data,
         });
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   COMPARISONOVERVIEW_PAGE_DATA_FETCH: async ({ commit }) => {
      const mutation = 'SET_COMPARISIONOVERVIEW_DATA';

      try {
         const response = await $service.get('/comparisonOverview');
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   ADMIN_VIEW: ({ commit }, flag = 1) => {
      commit('SET_ADMIN_VIEW', {
         data: flag,
      });
   },

   ADMIN_CONFIGURATION_FETCH: async ({ commit }) => {
      const mutation = 'SET_ADMIN_CONFIGURATION';
      try {
         const response = await $service.getAdmin(`/admin/settings`);
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },

   ADMIN_CONFIGURATION_UPDATE: async ({ commit }, data) => {
      try {
         await $service.putAdmin(`/admin/settings`, data);
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         return false;
      }
   },
   OVERVIEW_FUSION_GRID_PAGE_DATA_FETCH: async ({ commit }) => {
      const mutation = 'SET_OVERVIEW_FUSIONGRID_PAGE_DATA';

      try {
         const response = await $service.get('/explore/fusiongrid');
         commit(mutation, {
            data: response.data,
         });
         return true;
      } catch (err) {
         console.log((err && err.response && err.response.status) || err);
         if (err && err.response && err.response.status === 404) {
            commit(mutation, {
               data: false,
            });
         }
         return false;
      }
   },
   FUSION_GRID_DETAILS_FETCH: ({ commit }, payload) =>
      $service
         .get(`/fusiongrid/examples/${payload.slug}`)
         .then(response =>
            commit('SET_FUSION_GRID_DETAILS_FETCH', {
               data: response.data,
            })
         )
         .catch(err => {
            console.log((err && err.response && err.response.status) || err);
            if (err && err.response && err.response.status === 404) {
               commit('SET_FUSION_GRID_DETAILS_FETCH', {
                  data: false,
               });
            }
         }),

   FUSIONGRID_DATA_FETCH: ({ commit, state }) =>
      state.fusionGridData
         ? true
         : $service
              .get('/fusiongridPage')
              .then(response =>
                 commit('SET_FUSIONGRID_PAGE_DATA', {
                    data: response.data,
                 })
              )
              .catch(error => {
                 console.log(error);
              }),
};
